import { RiSendPlaneFill } from "react-icons/ri";
import { BsFillChatDotsFill } from "react-icons/bs";
import { FaCoffee } from "react-icons/fa";

export const help = [
  {
    id: 1,
    color: "#85DFD8",
    title: "In-home assessments",
    description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit.',
    url: "/",
    icon: RiSendPlaneFill,
  },
  {
    id: 2,
    color: "#1894E1",
    title: "Chart reviews",
    description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit.',
    url: "/",
    icon: FaCoffee,
  },
  {
    id: 3,
    color: "#13BFBF",
    title: "24/7 support",
    description: 'Lorem ipsum dolor sit amet consectetur adipiscing elit.',
    url: "/",
    icon: BsFillChatDotsFill,
  },
];
